import React, { useEffect, useRef, useState } from "react";
import { Slide } from "react-awesome-reveal";
import Modal from "../../../components/modal";
import MainPage from "../../MainPage/MainPage";
import TopBar from "../../../components/topbar";
import BottomBar from "../../../components/bottomBar";

const MobileMCQS = () => {
  const videoRef = useRef();
  const questions = [
    {
      id: "1",
      title: "how are you ?",
      answers: [
        { id: "1", title: "old", valid: true },
        { id: "2", title: "new", valid: false },
      ],
    },
    {
      id: "2",
      title: "how are you ?",
      answers: [
        { id: "1", title: "old2", valid: false },
        { id: "2", title: "new2", valid: true },
      ],
    },
    {
      id: "3",
      title: "how are you ?",
      answers: [
        { id: "1", title: "old3", valid: true },
        { id: "2", title: "new3", valid: false },
      ],
    },
    {
      id: "4",
      title: "how are you ?",
      answers: [
        { id: "1", title: "old4", valid: true },
        { id: "2", title: "new4", valid: false },
      ],
    },
  ];
  const [isPlayed, setIsPlayed] = useState(true);
  const [toTry, setToTry] = useState(false);
  const [finishCheck, setFinishCheck] = useState(false);
  const [finished, setFinished] = useState(false);
  const [checkedLi, setCheckedLi] = useState(null);
  let [currentQuestion, setCurrentQuestion] = useState(0);
  const [validAnswer, setValidAnswer] = useState(null);
  const [validAnswers, setValidAnswers] = useState([]);
  useEffect(() => {
    if (videoRef.current)
      videoRef.current.addEventListener("ended", () => {
        setIsPlayed(false);
      });
  }, [videoRef.current]);
  useEffect(() => {
    if (finished) {
      console.log(validAnswers);
      setFinished(false);
    }
  }, [finished]);

  return (
    // <div>
    <div direction="left" className="slideFeatures">
      <div class="device">
        <TopBar />
        {toTry ? (
          <div>
            <MainPage />
          </div>
        ) : (
          <div className="video" style={{ marginTop: "0", height: "87%" }}>
            <video
              ref={videoRef}
              src={require("../../../Assets/videos/mcq.mp4")}
              muted
              autoPlay
              controls
            ></video>
            {isPlayed ? null : (
              <div className="video_overLay">
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    setIsPlayed(true);
                    videoRef.current.play();
                  }}
                >
                  Replay
                </button>
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    setToTry(true);
                  }}
                >
                  Try
                </button>
              </div>
            )}
          </div>
        )}
        <BottomBar />
      </div>
    </div>
    // </div>
  );
};

export default MobileMCQS;
